/* jscpd:ignore-start */
/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { init } from '@rematch/core';
import { Store } from 'redux';

import { RematchRootState, RematchRootDispatch } from 'types/rematch-fix.d';
import * as models from './models';

export type RootState = RematchRootState<typeof models>;
export type RootDispatch = RematchRootDispatch<typeof models>;

export default init({ models }) as Store<RootState>;
/* jscpd:ignore-end */
